import './App.css';
import { BrowserRouter, Routes, Route } from "react-router-dom";
import AdminRoutes from "./routes/AdminRoutes";
import UserRoutes from "./routes/UserRoutes";
import SignInScreen from "./pages/SignInScreen";
import ProtectedRoute from "./routes/ProtectedRoutes";
import AdminProtectedRoute from "./routes/AdminProtectedRoute";

// PUBLIC PAGES
import AboutPage from "./pages/user/AboutPage";
import FAQScreen from "./pages/user/FAQScreen";
import ContactUs from "./pages/user/ContactUs";

function App() {
  return (
    <BrowserRouter>
      <Routes>

        {/* Public route */}
        <Route path="/" element={<SignInScreen />} />

        {/* PUBLIC pages (Fix for your navbar buttons) */}
        <Route path="/about" element={<AboutPage />} />
        <Route path="/faq" element={<FAQScreen />} />
        <Route path="/contact" element={<ContactUs />} />
        
        {/* Protected user routes */}
        <Route
          path="/user/*"
          element={
            <ProtectedRoute>
              <UserRoutes />
            </ProtectedRoute>
          }
        />

        {/* Protected admin routes */}
        <Route
          path="/admin/*"
          element={
            <AdminProtectedRoute>
              <AdminRoutes />
            </AdminProtectedRoute>
          }
        />

      </Routes>
    </BrowserRouter>
  );
}

export default App;
